import { Children, isValidElement, type ReactNode } from 'react';
/**
 * @deprecated Use {@link [partitionChildren](./partitionChildren.ts)}, or its associated hook, instead.
 */
export const getChildrenOfType = (
  children: ReactNode,
  ...expectedTypes: string[]
): ReactNode[] => {
  type TrickyReactElementWithDisplayNameReference = {
    type: { displayName: string };
  };
  return Children.toArray(children).filter(
    (item) =>
      isValidElement(item) &&
      expectedTypes.includes(
        (item as unknown as TrickyReactElementWithDisplayNameReference).type
          .displayName,
      ),
  );
};

/**
 * @deprecated Use {@link [partitionChildren](./partitionChildren.ts)}, or its associated hook, instead.
 */
export const excludeChildrenOfType = (
  children: ReactNode,
  ...expectedTypes: string[]
): ReactNode[] => {
  type TrickyReactElementWithDisplayNameReference = {
    type: { displayName: string };
  };
  return Children.toArray(children).filter(
    (item) =>
      !isValidElement(item) ||
      !expectedTypes.includes(
        (item as unknown as TrickyReactElementWithDisplayNameReference).type
          .displayName,
      ),
  );
};
